"use client";

import { PORTALS } from ".constants/portals";
import {
  Input,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Text,
  PortalModal,
  usePortalContext,
  Button,
} from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC } from "react";

import { useUploadPhotoByUrlForm } from "./hooks";

export const AttachPhotoByUrlPortal: FC = () => {
  const t = useTranslations("AttachPhotoByUrlModal");
  const { closePortal, openPortal } = usePortalContext();

  const {
    loading,
    photoLink,
    onSetPhotoLink,
    onResetPhotoLink,
    onClickUpload,
  } = useUploadPhotoByUrlForm(closePortal);

  const handleClose = () => {
    closePortal();
    onResetPhotoLink();
    openPortal(PORTALS.USER_FLOW_UPLOAD);
  };

  return (
    <PortalModal
      portalId={PORTALS.ATTACH_PHOTO_BY_URL}
      repositionInputs={false}
      onClose={handleClose}
    >
      <ModalHeader>{t("title")}</ModalHeader>

      <ModalContent>
        <Text text={t("text")} center />

        <Input
          placeholder="https://www..."
          value={photoLink}
          onChange={onSetPhotoLink}
          onReset={onResetPhotoLink}
          minLength={5}
          icon="content_paste"
          disabled={loading}
        />
      </ModalContent>

      <ModalFooter>
        <Button
          size="xl"
          color="primary"
          wide
          centerText
          onClick={onClickUpload}
          loading={loading}
          disabled={!photoLink}
        >
          {t("buttonText")}
        </Button>
      </ModalFooter>
    </PortalModal>
  );
};
